import React, { useState, useEffect, useMemo } from 'react';
import { Form } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { exibirTabelaPreco } from '~/Services/Service';
import { default as Selector } from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { FaPrint } from 'react-icons/fa';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';
const EmpreendimentoSelector = ({
  options,
  value,
  onChange,
  loading,
  error,
  onBlurSearch,
  searchLoading,
  searchError,
}) => {
  const selectedOption =
    options.find(opt => String(opt.value) === String(value)) || null;
  return (
    <div className="d-flex flex-wrap align-items-center my-3">
      <label
        htmlFor="selector-emp"
        className="mr-2"
        style={{ minWidth: '120px', textAlign: 'right' }}
      >
        Empreendimento:
      </label>
      <div style={{ flex: '1', minWidth: '300px' }}>
        <Selector
          inputId="selector-emp"
          styles={customStyles}
          components={{ DropdownIndicator }}
          name="empreendimento"
          isSearchable={true}
          isClearable={true}
          options={options}
          value={selectedOption}
          onChange={selected => {
            onChange({ target: { value: selected ? selected.value : '' } });
            if (selected && selected.value) {
              setTimeout(() => onBlurSearch(selected.value), 100);
            }
          }}
          placeholder="Todos..."
          isDisabled={loading || options.length === 0}
          isLoading={loading || searchLoading || options.length === 0}
        />
      </div>
      {error && (
        <small className="text-danger ml-2" role="alert">
          {error}
        </small>
      )}
      {searchError && (
        <small className="text-danger ml-2" role="alert">
          {searchError}
        </small>
      )}
    </div>
  );
};
const TabelaPrecoSelector = ({
  show,
  empreendimentoCodigo,
  value,
  onChange,
  fetchFn,
  onBlurConfirm,
  confirmLoading,
  prefetched,
  exibirProgramadas,
  setExibirProgramadas,
  searchPerformed,
  hasProgramadas,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!show || !empreendimentoCodigo) return;
    setLoading(true);
    setError(null);
    setOptions([]);
    let aborted = false;
    (async () => {
      try {
        let lista = [];
        if (Array.isArray(prefetched)) {
          lista = prefetched;
        } else {
          lista = [];
        }
        if (aborted) return;
        if (!Array.isArray(lista))
          throw new Error('Resposta inválida do servidor');
        const mapped = lista
          .filter(
            item =>
              item && (item.codigo || item.id) && (item.descricao || item.nome)
          )
          .map(item => ({
            value: item.codigo != null ? item.codigo : item.id,
            label: item.descricao || item.nome,
          }));
        setOptions(mapped);
        const selectedExists = mapped.some(
          opt => String(opt.value) === String(value)
        );
        if (!selectedExists) onChange({ target: { value: '' } });
      } catch (e) {
        setError(e && e.message ? e.message : 'Falha ao carregar tabelas');
      } finally {
        setLoading(false);
      }
    })();
    return () => {
      aborted = true;
    };
  }, [show, empreendimentoCodigo, fetchFn, prefetched]);

  if (!show) return null;
  const isDisabled = loading || Boolean(error);
  const isEmpty = !loading && !error && options.length === 0;

  return (
    <div className="d-flex flex-wrap align-items-center my-3 ml-1">
      <label
        htmlFor="selector-tab"
        className="mr-2"
        style={{ minWidth: '120px', textAlign: 'left' }}
      >
        Tabelas Disponíveis:
      </label>
      <div style={{ flex: '1', minWidth: '300px' }}>
        <Selector
          inputId="selector-tab"
          styles={{ customStyles }}
          components={{ DropdownIndicator }}
          name="tabela"
          isSearchable={true}
          isClearable={true}
          options={options}
          value={
            options.find(opt => String(opt.value) === String(value)) || null
          }
          onChange={selected => {
            const newValue = selected ? selected.value : '';
            onChange({ target: { value: newValue } });
            if (selected && selected.value) {
              setTimeout(() => onBlurConfirm(selected.value), 100);
            }
          }}
          placeholder={
            loading
              ? 'Carregando...'
              : error
              ? 'Erro ao carregar'
              : 'Selecione uma tabela...'
          }
          isDisabled={isDisabled}
          isLoading={loading || confirmLoading}
          noOptionsMessage={() => 'Nenhuma tabela disponível'}
        />
      </div>
      {searchPerformed && hasProgramadas && (
        <Form.Check
          type="switch"
          label={<span style={{ marginLeft: '5px' }}>Exibir Programadas</span>}
          checked={exibirProgramadas}
          onChange={e => setExibirProgramadas(e.target.checked)}
          style={{ cursor: 'pointer' }}
          id="checkbox-programadas"
        />
      )}
      {error && (
        <small className="text-danger ml-2" role="alert">
          {error}
        </small>
      )}
    </div>
  );
};

TabelaPrecoSelector.propTypes = {
  show: PropTypes.bool.isRequired,
  empreendimentoCodigo: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  fetchFn: PropTypes.func,
  onBlurConfirm: PropTypes.func,
  confirmLoading: PropTypes.bool,
  exibirProgramadas: PropTypes.bool,
  setExibirProgramadas: PropTypes.func,
  searchPerformed: PropTypes.bool,
  hasProgramadas: PropTypes.bool,
};

const ListarTabelaDePrecos = () => {
  const [selectedEmpreendimento, setSelectedEmpreendimento] = useState('');
  const [selectedTabela, setSelectedTabela] = useState('');
  const [tabelaData, setTabelaData] = useState(null);
  const [tabelaLoading, setTabelaLoading] = useState(false);
  const [tabelaError, setTabelaError] = useState(null);
  const [tabelaUrl, setTabelaUrl] = useState('');
  const [showTabelaSelector, setShowTabelaSelector] = useState(false);
  const [hasProgramadas, setHasProgramadas] = useState(false);
  const [expandedCards, setExpandedCards] = useState({});
  const [iframeLoading, setIframeLoading] = useState(false);
  const [iframeError, setIframeError] = useState(null);
  const [exibirProgramadas, setExibirProgramadas] = useState(false);

  const toggleCard = idx => {
    setExpandedCards(prev => {
      const next = { ...prev };
      next[idx] = !prev[idx];
      return next;
    });
  };

  const [empOptions, setEmpOptions] = useState([]);
  const [empLoading, setEmpLoading] = useState(false);
  const [empError, setEmpError] = useState(null);
  const [empBuscarLoading, setEmpBuscarLoading] = useState(false);
  const [empBuscarError, setEmpBuscarError] = useState(null);
  const [preFetchedTabelas, setPreFetchedTabelas] = useState(null);

  const empreendimentos = useSelector(state => state.empreendimentos);
  const tabelasDePreco = useSelector(state => state.tabelasDePreco);

  useEffect(() => {
    setEmpLoading(true);
    setEmpError(null);
    try {
      let origem = [];
      if (empreendimentos && Array.isArray(empreendimentos.sort)) {
        origem = empreendimentos.sort.map(item => ({
          value: item.codigo,
          label: item.codigo + ' - ' + item.descricao,
        }));
      }
      if (!origem || origem.length === 0) {
        setEmpOptions([]);
      } else {
        setEmpOptions(origem);
      }
    } catch (e) {
      setEmpError(e.message || 'Falha ao carregar empreendimentos');
    } finally {
      setEmpLoading(false);
    }
  }, [empreendimentos]);

  const isAvailable = item => {
    if (!item) return false;
    if (typeof item.disponivel !== 'undefined') return Boolean(item.disponivel);
    if (typeof item.ativo !== 'undefined') return Boolean(item.ativo);
    if (typeof item.habilitado !== 'undefined') return Boolean(item.habilitado);
    if (typeof item.status === 'string') {
      var s = String(item.status).toLowerCase();
      return ['inativo', 'indisponivel', 'desativado'].indexOf(s) === -1;
    }
    return true;
  };

  const fetchTabelasDisponiveisApi = async codigo => {
    const res = await api.buscarTabelasDisponiveis(codigo);
    return res;
  };

  const handleBuscarTabelasEmpreendimento = async codigoParam => {
    const codigo = codigoParam || selectedEmpreendimento;
    if (!codigo) return;
    try {
      setEmpBuscarError(null);
      setEmpBuscarLoading(true);
      const res = await fetchTabelasDisponiveisApi(codigo);
      let lista = [];
      if (Array.isArray(res)) {
        lista = res;
      } else if (res && Array.isArray(res.sort)) {
        lista = res.sort;
      } else if (res && Array.isArray(res.data)) {
        lista = res.data;
      }
      setPreFetchedTabelas(lista);
      setSelectedTabela('');
      setTabelaData(null);
      setShowTabelaSelector(true);
      if (!lista || lista.length === 0) {
        toast.warning('Nenhuma tabela disponível para este empreendimento');
      }
    } catch (e) {
      setPreFetchedTabelas(null);
      setEmpBuscarError(e && e.message ? e.message : 'Falha ao buscar tabelas');
      toast.error(e && e.message ? e.message : 'Falha ao buscar tabelas');
    } finally {
      setEmpBuscarLoading(false);
    }
  };

  const handleTabelaChange = e => {
    const codigo =
      e && e.target && typeof e.target.value !== 'undefined'
        ? e.target.value
        : '';
    setSelectedTabela(codigo);
    setTabelaData(null);
    setTabelaError(null);
    setTabelaUrl('');
    setIframeLoading(false);
    setIframeError(null);
  };

  const handleConfirmLoad = async (codigoParam, useProgramadasParam) => {
    const codigo = codigoParam || selectedTabela;
    if (!codigo) return;

    const useProgramadas =
      typeof useProgramadasParam === 'boolean'
        ? useProgramadasParam
        : exibirProgramadas;

    try {
      setTabelaError(null);
      setTabelaLoading(true);
      const res = await exibirTabelaPreco(
        codigo,
        selectedEmpreendimento,
        useProgramadas
      );
      setTabelaData(res || null);
      setTabelaUrl(res.url);
      if (res.programadas === 'S') {
        setHasProgramadas(true);
      } else {
        setHasProgramadas(false);
      }
      setIframeLoading(true);
      setIframeError(null);
      toast.success('Tabela carregada com sucesso');
    } catch (err) {
      setTabelaError(
        err && err.message ? err.message : 'Falha ao carregar a tabela'
      );
      toast.error(
        err && err.message ? err.message : 'Falha ao carregar a tabela'
      );
    } finally {
      setTabelaLoading(false);
    }
  };

  const handleProgramadasChange = checked => {
    setExibirProgramadas(checked);
    handleConfirmLoad(selectedTabela, checked);
  };

  return (
    <div
      className="container-fluid bg-light p-3"
      style={{ minHeight: '100vh' }}
    >
      <div className="lotes-header py-3 mb-3">
        <div className="d-flex align-items-center justify-content-between px-3">
          <h4 className="lotes-header__title mb-0">Tabelas de preços</h4>
        </div>
      </div>
      <div className="bg-white rounded p-3 my-3 shadow-sm border">
        <div className="row">
          <div className="col-md-6">
            <EmpreendimentoSelector
              options={empOptions}
              value={selectedEmpreendimento}
              onChange={e => {
                setSelectedEmpreendimento(e.target.value);
                setSelectedTabela('');
                setTabelaData(null);
                setPreFetchedTabelas(null);
                setTabelaUrl('');
                setShowTabelaSelector(false);
              }}
              loading={empLoading}
              error={empError}
              onBlurSearch={handleBuscarTabelasEmpreendimento}
              searchLoading={empBuscarLoading}
              searchError={empBuscarError}
            />
          </div>
          <div className="col-md-6">
            <TabelaPrecoSelector
              show={Boolean(showTabelaSelector)}
              empreendimentoCodigo={selectedEmpreendimento}
              value={selectedTabela}
              onChange={handleTabelaChange}
              onBlurConfirm={handleConfirmLoad}
              confirmLoading={tabelaLoading}
              fetchFn={fetchTabelasDisponiveisApi}
              prefetched={preFetchedTabelas}
              exibirProgramadas={exibirProgramadas}
              setExibirProgramadas={handleProgramadasChange}
              searchPerformed={!!tabelaUrl}
              hasProgramadas={hasProgramadas}
            />
          </div>
        </div>
      </div>

      {selectedEmpreendimento && tabelaUrl && (
        <div
          className="bg-white rounded shadow-sm border"
          aria-live="polite"
          aria-busy={tabelaLoading}
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100vh - 250px)',
            minHeight: '100vh',
          }}
        >
          <div
            className="p-3 border-bottom"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexShrink: 0,
            }}
          >
            <div className="d-flex align-items-center">
              {tabelaError && (
                <small className="text-danger" role="alert">
                  {tabelaError}
                </small>
              )}
              {iframeError && (
                <small className="text-danger" role="alert">
                  {iframeError}
                </small>
              )}
            </div>
            <button
              type="button"
              className="btn btn-primary d-flex align-items-center"
              aria-label="Imprimir tabela de preços"
              onClick={() => window.open(tabelaUrl, '_blank')}
              disabled={!tabelaData || tabelaLoading}
            >
              <FaPrint className="mr-2" />
              <span>IMPRIMIR / SALVAR TABELA</span>
            </button>
          </div>

          <div style={{ flex: 1, padding: '12px', overflow: 'hidden' }}>
            <object
              data={tabelaUrl}
              type="application/pdf"
              style={{
                width: '100%',
                height: '100%',
                border: '2px solid #dee2e6',
                borderRadius: '4px',
                backgroundColor: '#f8f9fa',
              }}
              onLoad={() => setIframeLoading(false)}
            >
              <iframe
                src={tabelaUrl}
                title="Tabela de Preço"
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                }}
                sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
                allow="fullscreen"
                referrerPolicy="no-referrer"
                onLoad={() => setIframeLoading(false)}
                onError={() => {
                  setIframeError(
                    'Falha ao exibir a tabela. Clique em "Imprimir / Salvar" para visualizar.'
                  );
                  setIframeLoading(false);
                }}
              />
            </object>
          </div>
        </div>
      )}
    </div>
  );
};
export default withRouter(ListarTabelaDePrecos);
